import { render, staticRenderFns } from "./totalChart.vue?vue&type=template&id=3f3f44c3&"
import script from "./totalChart.vue?vue&type=script&lang=js&"
export * from "./totalChart.vue?vue&type=script&lang=js&"
import style0 from "./totalChart.vue?vue&type=style&index=0&id=3f3f44c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports